import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appMyAutofocus]'
})
export class MyAutofocusDirective implements AfterViewInit {

  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    this.el.nativeElement.focus();
  }

}
